import { ref, computed } from 'vue';

import { useClientsStore } from '../store/clients';

export function useSearchClients() {
  const clientsStore = useClientsStore();

  const search = ref('');

  const searchedClients = computed(() => {
    return clientsStore.data?.filter((client) => {
      return `${client.first_name} ${client.last_name}`
        .toLocaleLowerCase()
        .includes(search.value.toLocaleLowerCase());
    });
  });

  return {
    search,
    searchedClients,
  };
}
